/**
 * Language Configuration
 * This file is auto-generated based on the LANGUAGE environment variable
 * Used to configure the site language
 * 
 * Generated at: 2026-03-30T14:16:59.103Z
 */

// Language code from environment variable (set at build time)
export const LANGUAGE = 'de'

export default LANGUAGE
